import styled from "styled-components";

export const SBreadcrumbRight = styled.div`
    margin-left: auto;
`;
